import {Component, Inject} from "@angular/core";
import {AbstractProdForm, ProdFormField, ProdFormFieldType, ProdFormValidators, RequiredValidator} from 'prod-form';
import {ProdDialogData} from 'prod-dialog';
import {ProdGridColumnType} from 'prod-grid';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {OrganizationTreeSelect} from "../../../../dip/organization-tree-select";
import {OrganizationUserGroupService} from "../../../../services/organization-user-group.service";
import {UserService} from "../../../../services/user.service";
import {PermissionService} from "../../../../services/permission.service";
import {RoleService} from "../../../../services/role.service";
import {Role} from "../../../../dip/role";
import {DipColumn} from "../../../../dip/dip-column";
import {HttpFilterParam} from 'prod-shared';
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-company-group-form',
  templateUrl: './company-group-form.html'
})

export class CompanyGroupForm extends AbstractProdForm {
  title: string = this.translate.instant('company.groups.form.title');
  private isFieldsEditable: boolean = this.roleService.hasRole([Role.ROLE_ORGANIZATION_USER_GROUP_EDIT]);
  fields: ProdFormField[] = [
    ProdFormField.create({
      name: 'userGroup_name',
      label: this.translate.instant('company.groups.form.name'),
      type: ProdFormFieldType.TEXT,
      validators: new ProdFormValidators([
        new RequiredValidator()
      ]),
      isEditable: this.isFieldsEditable
    }),
    ProdFormField.create({
      name: 'userGroup_description',
      label: this.translate.instant('company.groups.form.description'),
      type: ProdFormFieldType.TEXTAREA,
      isEditable: this.isFieldsEditable
    }),
    ProdFormField.create({
      name: 'userGroup_users',
      label: this.translate.instant('company.groups.form.users'),
      type: ProdFormFieldType.GRID,
      gridParameter: {
        service: UserService,
        displayColumn: DipColumn.get({property: 'username', type: ProdGridColumnType.STRING}),
        extraColumns: [
          DipColumn.get({property: 'firstName', type: ProdGridColumnType.STRING}),
          DipColumn.get({property: 'lastName', type: ProdGridColumnType.STRING}),
        ],
        filter: new HttpFilterParam({
          property: 'groups.organizationUserGroup.organization',
          operator: 'eq',
          value: this.organizationTreeSelect.company.id
        })
      },
      isEditable: this.isFieldsEditable
    }),
    ProdFormField.create({
      name: 'permissions',
      label: this.translate.instant('company.groups.form.permissions'),
      type: ProdFormFieldType.GRID,
      gridParameter: {
        service: PermissionService,
        displayColumn: DipColumn.get({property: 'name', type: ProdGridColumnType.STRING}),
        extraColumns: [
          DipColumn.get({property: 'description', type: ProdGridColumnType.STRING}),
        ],
        filter: new HttpFilterParam({
          property: 'module',
          operator: 'in',
          value: ['company']
        })
      },
      isEditable: this.isFieldsEditable
    }),
    ProdFormField.create({
      name: 'organization',
      label: null,
      type: ProdFormFieldType.HIDDEN,
      value: this.organizationTreeSelect.company.id,
      isEditable: this.isFieldsEditable
    }),
  ]

  constructor(
    dialogRef: MatDialogRef<CompanyGroupForm>,
    @Inject(MAT_DIALOG_DATA)
    public dialogData: ProdDialogData,
    override dataService: OrganizationUserGroupService,
    private roleService: RoleService,
    private organizationTreeSelect: OrganizationTreeSelect,
    private translate: TranslateService) {
    super();
  }
}
